export const ONBOARDING_STATUS = {
  ORG_CREATED: "org_created",
  SERVICES_SUBSCRIBED: "services_subscribed",
  SKIPPED: "skipped",
  TEST_APP_CREATED: "test_app_created",
  SERVICES_ADDED: "services_added",
  ONBOARDING_COMPLETED: "onboarding_completed",
  ACTIVATION_REQUESTED: "activation_requested",
  ACCOUNT_ACTIVATED: "account_activated",
  PLAN_SUBSCRIBED: "plan_subscribed",
};

export function normalizeOnboardingStatus(status?: string): string {
  return (status || "").trim().toLowerCase();
}
